export default {
	title: 'Failure Case',
	selectAll: 'Select All',
	selectedCount: 'Selected {count} items',
	batchDelete: 'Batch Delete',
	batchDeleteWithCount: 'Batch Delete ({count})',
	noData: {
		title: 'No Failure Cases',
		description: 'No failure case data found'
	},
	reportCard: {
		coverAlt: 'Failure Case Cover',
		author: 'Author',
		reviewer: 'Reviewer',
		approver: 'Approver',
		updateTime: 'Update Time'
	},
	status: {
		completed: 'Completed',
		editing: 'Editing'
	},
	actions: {
		generateReport: 'Generate Report',
		download: 'Download',
		delete: 'Delete',
		edit: 'Edit',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Delete successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		fileUploadSuccess: 'File upload successful',
		fileUploadError: 'File upload failed',
		fileTypeError: 'Only PDF and Word document formats are allowed!',
		fileSizeError: 'File size cannot exceed 10MB!',
		generateReportSuccess: 'Report generated successfully'
	},
	form: {
		orgId: 'Organization',
		reportName: 'Report Name',
		inspectDeviceReportId: 'Related Inspection Report',
		author: 'Author',
		reviewer: 'Reviewer',
		approver: 'Approver',
		analysis: 'Analysis',
		advice: 'Advice',
		adviceAttachment: 'Advice Attachment',
		follow: 'Follow-up',
		followAttachment: 'Follow-up Attachment',
		warnInfo: 'Warning Information',
		sensorDiagram: 'Sensor Diagram',
		installConfig: 'Installation Configuration',
		attachment: 'Attachment Upload',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		add: 'Add',
		update: 'Update',
		cancel: 'Cancel',
		confirm: 'Confirm',
		startDate: 'Start Date',
		endDate: 'End Date',
		fileUpload: 'Click to Upload'
	},
	table: {
		reportName: 'Report Name',
		fileName: 'Failure Case',
		inspectDeviceReportName: 'Related Inspection Report',
		author: 'Author',
		analysis: 'Analysis',
		advice: 'Advice',
		createTime: 'Create Time'
	},
	warnItem: {
		warnItem: 'Warning Item',
		faultLocation: 'Fault Location',
		faultType: 'Fault Type',
		selectFaultType: 'Please select fault type',
		warnLevel: 'Warning Level',
		selectWarnLevel: 'Please select warning level',
		warnCount: 'Warning Count',
		diagnosisAnalysis: 'Diagnosis Analysis',
		enterDiagnosisAnalysis: 'Please enter diagnosis analysis',
		relatedAtlas: 'Related Atlas',
		addAtlas: 'Add Atlas',
		diagnosisConclusion: 'Diagnosis Conclusion',
		enterDiagnosisConclusion: 'Please enter diagnosis conclusion',
		maintenanceSuggestion: 'Maintenance Suggestion',
		enterMaintenanceSuggestion: 'Please enter maintenance suggestion',
		warnStartTime: 'Warning Start Time',
		warnEndTime: 'Warning End Time',
		selectDateAndTime: 'Select date and time'
	},
	vibrationData: {
		deviceName: 'Device Name',
		sensorLoc: 'Sensor Location',
		axial: 'Axial Direction',
		sensorType: 'Sensor Type',
		enterDeviceName: 'Please enter device name',
		enterSensorLoc: 'Please enter sensor location',
		enterAxial: 'Please enter axial direction',
		enterSensorType: 'Please enter sensor type',
		addVibrationData: 'Add Vibration Data'
	},
	placeholder: {
		selectOrg: 'Please select organization',
		enterReportName: 'Please enter report name',
		selectInspectReport: 'Please select related inspection report',
		enterAuthor: 'Please enter author',
		enterReviewer: 'Please enter reviewer',
		enterApprover: 'Please enter approver',
		enterAnalysis: 'Please enter analysis',
		enterAdvice: 'Please enter advice',
		enterFollow: 'Please enter follow-up',
		fileUpload: 'File Upload'
	}
}
